// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  voteId: __t.u64().primaryKey().name("vote_id"),
  termId: __t.u64().name("term_id"),
  voter: __t.identity(),
  candidate: __t.identity(),
  infSpent: __t.i64().name("inf_spent"),
  at: __t.timestamp(),
});
